import { render, staticRenderFns } from "./call.vue?vue&type=template&id=07d9766b&scoped=true&"
import script from "./call.vue?vue&type=script&lang=js&"
export * from "./call.vue?vue&type=script&lang=js&"
import style0 from "./call.vue?vue&type=style&index=0&id=07d9766b&prod&lang=scss&"
import style1 from "./call.vue?vue&type=style&index=1&id=07d9766b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d9766b",
  null
  
)

export default component.exports